"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isRaffle(object) {
    return checkRaffle(object).fulfilled;
}
exports.isRaffle = isRaffle;
function checkRaffle(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("id"), __1.hasNumber("startTime").integer(), __1.hasNumber("endTime").integer(), __1.hasNumber("resultTime").integer(), __1.hasBoolean("paused"), __1.hasNumber("maxNumberOfPrizes").integer(), __1.hasArray("winners", __1.isRecord(__1.hasString("ticketId"), __1.hasNumber("winningRank"))).optional().nullable()).withOptions(options).explain();
}
exports.checkRaffle = checkRaffle;
//# sourceMappingURL=Raffle.js.map